import React from 'react';
import { FieldTemplateProps } from '@rjsf/utils';

const HorizontalFieldTemplate = ({
    id,
    label,
    help,
    required,
    description,
    errors,
    children,
    displayLabel,
    classNames,
    disabled,
    readonly,
    schema,
    uiSchema,
    onKeyChange,
    onDropPropertyClick
}: FieldTemplateProps) => {
    // Don't render horizontal layout for checkboxes, which have their own layout
    if (schema.type === 'boolean') {
        return (
            <div className={`mb-2 ${classNames}`}>
                <div>{children}</div>
                {errors}
                {help}
                {description && (
                    <div className="form-description-container">
                        <div className="form-field-description">
                            {description}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    // For nested objects/arrays, use vertical layout
    if (schema.type === 'object' || schema.type === 'array') {
        return (
            <div className={`${classNames}`}>
                {displayLabel && label && <div>{label}</div>}
                <div>{children}</div>
                {errors}
                {help}
            </div>
        );
    }

    return (
        <div className={`mb-[8px] border-b border-divider-lines last:border-b-0 pb-[8px] last:pb-0 last:mb-0 ${classNames} transition-all duration-300 w-full`}>
            <div className="flex flex-row items-start justify-between w-full gap-6 mt-4 mb-4">
                <div className="w-1/2 flex flex-col pt-2">
                    <span className="mr-1 dark:text-white">{displayLabel && label}</span>
                    {description && (
                        <div className="mt-1">
                            <span className="text-secondary-gray dark:text-neutral-gray-400 text-sm">
                                {description}
                            </span>
                        </div>
                    )}
                </div>
                <div className="w-1/2">
                    <div className="p-2 dark:text-white">{children}</div>
                    {errors}
                    {help}
                </div>
            </div>
        </div>
    );
};

export default HorizontalFieldTemplate;
